import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=4cb6913e&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6913e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb6913e')) {
      api.createRecord('4cb6913e', component.options)
    } else {
      api.reload('4cb6913e', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=4cb6913e&scoped=true&", function () {
      api.rerender('4cb6913e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Account/Account.vue"
export default component.exports